import { useState, useCallback } from 'react';

import { validate as isValidUuid } from 'uuid';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import CardContent from '@zenbusiness/zui/CardContent';
import Text from '@zenbusiness/zui/Text';

import { HomeSection } from '#client/components/HomeSection';
import { AssistantUi } from '#client/directEntry/MFEs';

import * as Styled from './VeloChat.style';

function VeloChat() {
  const [threadUuid, setThreadUuid] = useState(null);

  const handleThreadChange = useCallback(({ threadUuid: nextThreadUuid }) => {
    setThreadUuid(isValidUuid(nextThreadUuid) ? nextThreadUuid : null);
  }, []);

  const assistantProps = {
    exportName: 'VeloChat',
    origination: 'dashboard-next-up',
    onThreadChange: handleThreadChange,
    ...(threadUuid ? { threadUuid } : {})
  };

  return (
    <HomeSection
      title={(
        <Text size="xl" weight="medium">
          <FormattedMessage id="dashboard.veloChat.title" />
        </Text>
      )}
    >
      <Styled.VeloChatWrapper color="default" variant="elevation" elevation={0} data-testid="velo-chat-wrapper">
        <CardContent>
          <AssistantUi {...assistantProps} />
        </CardContent>
      </Styled.VeloChatWrapper>
    </HomeSection>
  );
}

export default VeloChat;
